// import React, { useState, useRef, useEffect } from "react";

import ItemRelocateThreshold from "../../../../components/@operations/itemThreshold/ItemRelocateThreshold";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemRelocateThresholdPage() {

    return (
        <ItemRelocateThreshold
            routeType={routeTypes.workstation}
        />
    )
}